import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { TagType } from 'src/types';

interface TagProps extends TagType {
  endpoint: string;
  tagCount: number;
  textClass: string;
}

const Tag = (props: TagProps) => {
  const { slug, endpoint, tagCount, textClass } = props;
  return (
    <span
      className={ivclass(
        'iv-font-medium',
        'iv-text-black-50',
        'iv-overflow-hidden iv-overflow-ellipsis iv-whitespace-nowrap',
        `iv-max-w-[${300 / tagCount}px]`,
        'hover:iv-cursor-default',
        textClass,
      )}
    >
      {`#${slug.replace(/-/g, '')}`}
    </span>
  );
};

export default Tag;
